<template>
  <div class="accounts-collection-detail-bill">
    <custom-table
      :data="writeOffViewList"
      tableCode="accounts_col_detail_bill"
      height="500px"
      style="margin-top: 26px;"
      :slots="['termNum', 'finalPaymentTime']"
      :expand="true"
      row-key="writeoffId"
    >
      <template v-slot:finalPaymentTime="scope">
        {{$momentLocal(scope.row.expand[0].tradeFinishTime, 'YYYY-MM-DD')}}
      </template>
      <template v-slot:expand="scope">
        <div>
          <custom-table
            tableCode="collection_write_off_msg"
            @filter="filterChange"
            :data="scope.row.expand"
            :slots="['payMsg', 'receiveMsg', 'tradeResult']"
          >
            <template v-slot:payMsg>
              <div>
                <div class="msg-item">{{ $t('fms_accounts_collection_detail_bill.zhang_hu_ming_cheng') }}：{{scope.row.expand[0].buyerName}}</div>
                <div class="msg-item">{{ $t('fms_accounts_collection_detail_bill.yin_hang_zhang_hu') }}：{{scope.row.expand[0].buyerAccount}}</div>
                <div class="msg-item">{{ $t('fms_accounts_collection_detail_bill.kai_hu_yin_hang') }}：{{scope.row.expand[0].buyerBank}}</div>
              </div>
            </template>
            <template v-slot:receiveMsg>
              <div>
                <div class="msg-item">{{ $t('fms_accounts_collection_detail_bill.zhang_hu_ming_cheng') }}：{{scope.row.expand[0].sellerName}}</div>
                <div class="msg-item">{{ $t('fms_accounts_collection_detail_bill.yin_hang_zhang_hu') }}：{{scope.row.expand[0].sellerAccount}}</div>
                <div class="msg-item">{{ $t('fms_accounts_collection_detail_bill.kai_hu_yin_hang') }}：{{scope.row.expand[0].sellerBank}}</div>
              </div>
            </template>
            <template v-slot:tradeResult>
              <el-image
                v-if="scope.row.expand[0].attachs && scope.row.expand[0].attachs.length"
                style="width:69px;height: 69px;"
                :src="getAttachUrl(scope.row.expand[0].attachs[0])"
                :preview-src-list="[getAttachUrl(scope.row.expand[0].attachs[0])]"
                fit="contain"
              ></el-image>
            </template>
          </custom-table>
        </div>
      </template>
      <template v-slot:termNum="scope">
        {{ scope.row.termNum }}/{{ scope.row.totalTerm }}
      </template>
    </custom-table>
  </div>
</template>

<script>
// 查看收款信息-账单核销信息
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [],
  components: {
  },
  props: {
    billData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      writeOffViewList: [],
      orderViewList: [],
    };
  },
  computed: {
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    // 格式化attachs数据，与新增付款信息时保持一致
    formatAttachs(list) {
      list.forEach((item) => {
        if (!item.attachUrl) {
          item.attachUrl = item.attachPath;
          item.attachPath = this.$formatAttachPath(item.attachPath);
        }
      });
      return list;
    },
    formatList(list) {
      list.forEach((item) => {
        // 获取流水详情
        const row = {
        };
        item.expand = [row];
        const url = `${apis.tradeSellerInfo}/${item.sellerTradeCode}`;
        this.$getJSON(url).then((res) => {
          const data = res.data;
          Object.keys(data).forEach((key) => {
            const val = data[key];
            this.$set(row, key, val);
          });
        });

        // 获取交易凭证
        this.$getJSON(`${apis.OssAttach}/${item.tradeInId}/fms.trade.certificate`).then((imgRes) => {
          this.$set(row, 'attachs', this.formatAttachs(imgRes.data));
        });
      });
      return list;
    },
    getPageInfo() {
      const firstItem = this.orderViewList[0];
      this.$getJSON(`${apis.paymentPaymentInfo}/${firstItem.billId}`).then((res) => {
        const data = res.data;
        const { writeOffViewList } = data;
        if (writeOffViewList && writeOffViewList.length) {
          this.writeOffViewList = this.formatList(writeOffViewList);
        }
      });
    }
  },
  created() {
  },
  mounted() {
    this.orderViewList = this.billData;
    this.getPageInfo();
  },
};
</script>

<style lang="scss">
.accounts-collection-detail-bill {
  padding-top: 16px;
}
</style>
